export default {
      id: "Icon_Button_Editable-usage",
      viewBox: "3 4 18 18",
      url: __webpack_public_path__ + "img/icons.svg#Icon_Button_Editable",
      toString: function () {
        return this.url;
      }
    }